import React, { Fragment, useState } from "react";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, P } from "../AbstractElements";
import {
  EmailAddress,
  ForgotPassword,
  Password,
  RememberPassword,
} from "../Constant";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import man from "../assets/images/dashboard/1.png";
import SocialAuth from "./Tabs/LoginTab/SocialAuth";
import { Button, Center, PasswordInput } from "@mantine/core";
import useAuthStore from "../store/authStore";

const Login = ({ selected }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { login, isLoading, error, clearError } = useAuthStore();

  const handleLogin = async (e) => {
    e.preventDefault();
    clearError();
    const success = await login(username, password);
    if (success) {
      toast.success("Login successful");
      navigate("/dashboard");
    } else {
      toast.error(error || "Login failed");
    }
  };

  return (
    <Fragment>
      <div className="p-0 container-fluid">
        <Row>
          <Col className="col-12">
            <div className="login-card">
              <div className="login-main login-tab">
                <Form className="theme-form">
                  <Center>
                    <img src="/logo.png" alt="logo" width={180} className="mb-10" />
                  </Center>
                  <H4>Welcome Coach !</H4>
                  <P>{"Enter your username & password to login"}</P>
                  <FormGroup>
                    <Label className="col-form-label">Username</Label>
                    <Input
                      className="form-control"
                      type="text"
                      required
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </FormGroup>
                  <FormGroup className="position-relative">
                    <Label className="col-form-label">{Password}</Label>
                    <PasswordInput
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </FormGroup>
                  <div className="form-group mt-4">
                    <Button
                      fullWidth
                      size="lg"
                      loading={isLoading}
                      onClick={handleLogin}
                      disabled={isLoading || !username || !password}
                    >
                      Login
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Fragment>
  );
};

export default Login;
